export const productCategoryOptions = [
  {
    label: 'Video Plugin',
    value: 'Video Plugin',
  },
  {
    label: 'Subscription',
    value: 'Subscription',
  },
  {
    label: 'Bundle',
    value: 'Bundle',
  },
  {
    label: 'Upgrade',
    value: 'Upgrade',
  },
  {
    label: 'Photo Plugin',
    value: 'Photo Plugin',
  },
];

export const productIdOptions = [
  {
    label: 'Anarchy Cloud All Access',
    value: 'cloud-all-access',
  },
  {
    label: 'Anarchy Cloud One Host App',
    value: 'cloud-one-app',
  },
  {
    label: 'Anarchy Complete Bundle All Plugins',
    value: 'cloud-complete-bundle-all-plugins',
  },
  {
    label: 'Eff-It!',
    value: 'eff-it',
  },
  {
    label: 'Beauty Box',
    value: 'beauty-box',
  },
  {
    label: 'Beauty Box Photo',
    value: 'beauty-box-photo',
  },
  {
    label: 'Beauty Box Upgrade From 4.0',
    value: 'beauty-box-upgrade',
  },
  {
    label: 'Beauty Box Upgrade From 1.0, 2.0, or 3.0',
    value: 'beauty-box-upgrade-123',
  },
  {
    label: 'Beauty Box Photo Upgrade',
    value: 'beauty-box-photo-upgrade',
  },
  {
    label: 'Beauty Box Crossgrade',
    value: 'beauty-box-crossgrade',
  },
  {
    label: 'Data Storyteller',
    value: 'data-storyteller',
  },
  {
    label: 'Data Storyteller Crossgrade',
    value: 'data-storyteller-crossgrade',
  },
  {
    label: 'Flicker Free',
    value: 'flicker-free',
  },
  {
    label: 'Flicker Free 3',
    value: 'flicker-free-3',
  },
  {
    label: 'Flicker Free Upgrade 1.0 to 3.0',
    value: 'flicker-free-upgrade-1to3',
  },
  {
    label: 'Flicker Free Upgrade 2.0 to 3.0',
    value: 'flicker-free-upgrade-2to3',
  },
  {
    label: 'Flicker Free Crossgrade',
    value: 'flicker-free-crossgrade',
  },
  {
    label: 'Lightwrap',
    value: 'lightwrap',
  },
  {
    label: 'Lightwrap Crossgrade',
    value: 'lightwrap-crossgrade',
  },
  {
    label: 'Powersearch',
    value: 'powersearch',
  },
  {
    label: 'Samurai Sharpen',
    value: 'samurai-sharpen',
  },
  {
    label: 'Samurai Sharpen Crossgrade',
    value: 'samurai-sharpen-crossgrade',
  },
  {
    label: 'Transcriptive',
    value: 'transcriptive',
  },
  {
    label: 'Transcriptive Upgrade',
    value: 'transcriptive-upgrade',
  },
  {
    label: 'Placeholder',
    value: 'placeholder',
  },
];

export const platformOptions = [
  {
    label: 'Macintosh',
    value: 'Macintosh',
  },
  {
    label: 'Windows',
    value: 'Windows',
  },
];

// export const hostAppOptions = [
//   {
//     label: 'After Effects and Premiere Pro',
//     value: 'After Effects and Premiere Pro',
//   },
//   {
//     label: 'Final Cut Pro and Motion',
//     value: 'Final Cut Pro and Motion',
//   },
//   {
//     label: 'Avid',
//     value: 'Avid',
//   },
//   {
//     label: 'Open Fx - Nuke',
//     value: 'Open Fx - Nuke',
//   },
//   {
//     label: 'Open Fx - DaVinci Resolve',
//     value: 'Open Fx - DaVinci Resolve',
//   },
//   {
//     label: 'Photoshop',
//     value: 'Photoshop',
//   },
// ];
